module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [_c('div', {
    slot: "header"
  }, [_c('v-sub-header', [_c('template', {
    slot: "header"
  }, [_c('h2', [_vm._v("Muokkaa profiilia")])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "container bloc-md"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('ul', {
    staticClass: "nav nav-pills pull-right",
    attrs: {
      "id": "myTab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "pill",
      "href": "#basic-info",
      "role": "tab"
    }
  }, [_vm._v("Perustiedot")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "pill",
      "href": "#username-password",
      "role": "tab"
    }
  }, [_vm._v("Käyttäjätunnus ja salasana")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "pill",
      "href": "#messages",
      "role": "tab"
    }
  }, [_vm._v("Kuvat ja markkinointiteksti")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "pill",
      "href": "#settings",
      "role": "tab"
    }
  }, [_vm._v("Ilmoitukset")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "basic-info",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('h3', {
    staticClass: "mg-clear"
  }, [_c('strong', [_vm._v("Yhteyshenkilön tiedot")])]), _vm._v(" "), _c('div', {
    staticClass: "divider-h"
  }, [_c('span', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('v-form-group-input', {
    attrs: {
      "name": "firstName",
      "source": "account"
    }
  }, [_vm._v("\n              Etunimi\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('v-form-group-input', {
    attrs: {
      "name": "lastName",
      "source": "account"
    }
  }, [_vm._v("\n              Sukunimi\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('v-form-group-input', {
    attrs: {
      "name": "email",
      "source": "account"
    }
  }, [_vm._v("\n            Sähköposti\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v("\n                Yhteyshenkilön puhelinnumero\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "input_1366"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "divider-h"
  }, [_c('span', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "mg-clear section-header"
  }, [_vm._v("\n            Yrityksen tiedot\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider-h"
  }, [_c('span', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('v-form-group-input', {
    attrs: {
      "name": "organizationName",
      "source": "organization"
    }
  }, [_vm._v("\n              Yrityksen nimi\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("\n                Y-tunnus\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "input_857"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row section-header"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h3', {
    staticClass: "mg-clear"
  }, [_c('strong', [_vm._v("Yrityksen osoite")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider-h"
  }, [_c('span', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v("\n                Katuosoite\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "input_678"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("\n                Kaupunki\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "input_678"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("\n                Postinumero\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "input_678"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "divider-h"
  }, [_c('span', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-deep-magenta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.patchAccount($event)
      }
    }
  }, [_vm._v("Tallenna")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "username-password",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('h3', {
    staticClass: "mg-clear"
  }, [_c('strong', [_vm._v("Käyttäjätunnus ja salasana")])]), _vm._v(" "), _c('div', {
    staticClass: "divider-h"
  }, [_c('span', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n                Käyttäjätunnus\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control medium-field",
    attrs: {
      "id": "input_708"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n                Salasana\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control medium-field",
    attrs: {
      "id": "input_730"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n                Salasana uudelleen\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control medium-field",
    attrs: {
      "id": "input_1366"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })])]), _c('a', {
    staticClass: "btn btn-lg  pull-right btn-deep-magenta",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tallenna")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "messages",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('h3', {
    staticClass: "mg-clear"
  }, [_c('strong', [_vm._v("Kuvat ja markkinointiteksti")])]), _vm._v(" "), _c('div', {
    staticClass: "divider-h"
  }, [_c('span', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n                      Markkinointiteksti\n                    ")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "id": "marketing-text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  })])]), _c('a', {
    staticClass: "btn btn-lg  pull-right btn-deep-magenta",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tallenna")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "settings",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('h3', {
    staticClass: "mg-clear"
  }, [_c('strong', [_vm._v("Ilmoitukset")])]), _vm._v(" "), _c('div', {
    staticClass: "divider-h"
  }, [_c('span', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n                      Ilmoitus, jos palveluun tulee:\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v("Uusi tarjous")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v("Uusi kysymys tarjouspyynnöstä")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v("Neuvottelut aloitetaan toimittajan kanssa")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-44aaf117"}!./src/app/pages/profile-settings/profile-settings.html
// module id = 477
// module chunks = 1